module.exports = __webpack_public_path__ + "static/media/logoAnthem.17ecb17c.png";